import { render, staticRenderFns } from "./AssessmentApplicationDetails.vue?vue&type=template&id=0d8ba3e2&scoped=true"
import script from "./AssessmentApplicationDetails.vue?vue&type=script&lang=js"
export * from "./AssessmentApplicationDetails.vue?vue&type=script&lang=js"
import style0 from "./AssessmentApplicationDetails.vue?vue&type=style&index=0&id=0d8ba3e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8ba3e2",
  null
  
)

export default component.exports